import { unsupported } from "@thi.ng/errors/unsupported";
const vop = (dispatch = 0) => {
  const impls = new Array(5);
  let fallback;
  const fn = (...args) => {
    const g = impls[args[dispatch].length] || fallback;
    return g ? g(...args) : unsupported(`no impl for vec size ${args[dispatch].length}`);
  };
  fn.add = (dim, fn2) => impls[dim] = fn2;
  fn.default = (fn2) => fallback = fn2;
  fn.impl = (dim) => impls[dim] || fallback;
  return fn;
};
export {
  vop
};
